import React from 'react';

import {
    Chat,
    IChatProps,
} from '../../components/chat';

export interface ITemplateChatProps {
    chat: IChatProps;
}

const TemplateChat = (props: ITemplateChatProps): JSX.Element => (
    <Chat {...props.chat} />
);

export default TemplateChat;
